import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppCTA = () => {
  const [isMinimized, setIsMinimized] = useState(true);
  const phoneNumber = '+254100154411';
  const message = 'Hi, I need help with Bamo Tech Sphere products';

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber.replace('+', '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
    // Close the panel right after handing off to WhatsApp, instead of
    // leaving it sitting open on screen.
    setIsMinimized(true);
  };

  if (isMinimized) {
    return (
      <button
        onClick={() => setIsMinimized(false)}
        className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 shadow-xl"
        style={{ background: '#25D366' }}
        data-testid="whatsapp-button-minimized"
        aria-label="Open WhatsApp chat"
      >
        <MessageCircle size={28} color="white" />
      </button>
    );
  }

  return (
    <div
      className="fixed bottom-6 right-6 z-50 rounded-2xl shadow-2xl overflow-hidden transition-all duration-300"
      style={{ background: 'var(--color-surface)', border: '1px solid var(--color-border)', maxWidth: '320px' }}
      data-testid="whatsapp-cta"
    >
      {/* Header */}
      <div className="p-4 flex items-center justify-between" style={{ background: '#25D366' }}>
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-white flex items-center justify-center">
            <MessageCircle size={24} color="#25D366" />
          </div>
          <div>
            <p className="font-semibold text-white text-sm">Chat with us</p>
            <p className="text-white text-xs opacity-90">We're here to help!</p>
          </div>
        </div>
        <button
          onClick={() => setIsMinimized(true)}
          className="text-white hover:bg-white/20 rounded-full p-1 transition-colors"
          aria-label="Minimize"
        >
          <X size={20} />
        </button>
      </div>

      {/* Body */}
      <div className="p-4">
        <p className="text-sm mb-4" style={{ color: 'var(--color-text-secondary)' }}>
          Have questions about our products? Need help with your order? We're just a message away!
        </p>
        <button
          onClick={handleWhatsAppClick}
          className="w-full py-3 px-4 rounded-full font-semibold text-white flex items-center justify-center gap-2 transition-all duration-300 hover:scale-105"
          style={{ background: '#25D366' }}
          data-testid="whatsapp-chat-button"
        >
          <MessageCircle size={20} />
          Chat on WhatsApp
        </button>
        <p className="text-xs text-center mt-3" style={{ color: 'var(--color-text-muted)' }}>
          +254 100 154 411
        </p>
      </div>
    </div>
  );
};

export default WhatsAppCTA;
